export default "__VITE_ASSET__D8Plxxqb__"